import React from 'react'
import { Badge } from 'antd'
import PropTypes from 'prop-types'
import { THEME } from '../../../../core/constants'
import {
  VERBOSE,
  DEBUG,
  INFORMATION,
  WARNING,
  ERROR,
  FATAL,
  SCRAPING_LOGS_SEVERITIES,
} from '../../../constants'

const backgroundColorBySeverity = {
  [VERBOSE]: THEME.colors.blue,
  [DEBUG]: THEME.colors.blue,
  [INFORMATION]: THEME.colors.blue,
  [WARNING]: THEME.colors.yellow,
  [ERROR]: THEME.colors.red,
  [FATAL]: THEME.colors.red,
}

const ScrapingLogSeverity = ({ severity }) => (
  <Badge
    count={SCRAPING_LOGS_SEVERITIES[severity].name}
    style={{
      backgroundColor: backgroundColorBySeverity[severity],
      marginRight: '5px',
    }}
  />
)

ScrapingLogSeverity.propTypes = {
  severity: PropTypes.string.isRequired,
}

export default ScrapingLogSeverity
